
export default function WinzCentreApi({ makeRequest, buildRequest, baseUrl = '' }) {

    function getWinzCentres() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/winzcentre`));
        });
    }

    function updateWinzCentre(id, data) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/winzcentre/${id}`, data));
        });
    }

    function deleteWinzCentre(id) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`${baseUrl}/winzcentre/${id}`));
        });
    }

    function createWinzCentre(data) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/winzcentre`, data));
        });
    }

    function syncWinzCentre(centreId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post(`${baseUrl}/children/syncdata/${centreId}`));
        });
    }

    return {
        getWinzCentres,
        updateWinzCentre,
        deleteWinzCentre,
        createWinzCentre,
        syncWinzCentre
    }
}